import { createSlice } from '@reduxjs/toolkit';
import {
  confirmRefund,
  createRefund,
  fetchOrderAdmin,
  fetchOrdersAdmin,
  fetchStatMonthly,
  remindPayment,
  updateOrderAdmin,
} from '../actions/admin.room.action';

const initialState = {
  order: {
    data: [],
    detail: null,
    total: 0,
    isLoading: false,
    isNeedReloadData: false,
  },
  statMonthly: {
    data: null,
    isLoading: false,
    isNeedReloadData: true,
  },
  reminder: {
    data: null,
    isLoading: false,
    isNeedReloadData: true,
  },
  refund: {
    data: null,
    isLoading: false,
  },
};

export const adminRoomReducer = createSlice({
  name: 'AdminRoom',
  initialState,
  reducers: {
    reloadAdminOrders: state => {
      state.order.isNeedReloadData = true;
    },
    resetAdminOrdersData: state => {
      state.order.data = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOrdersAdmin.pending, state => {
        state.order = {
          ...state.order,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchOrdersAdmin.fulfilled, (state, action) => {
        if (action.payload) {
          const { data, total } = action.payload;
          state.order = { ...state.order, data, total, isLoading: false };
        }
      })
      .addCase(fetchOrdersAdmin.rejected, state => {
        state.order = { ...state.order, isLoading: false };
      })
      .addCase(fetchOrderAdmin.pending, state => {
        state.order = {
          ...state.order,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchOrderAdmin.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.order = { ...state.order, detail: data, isLoading: false };
        }
      })
      .addCase(fetchOrderAdmin.rejected, state => {
        state.order = { ...state.order, isLoading: false };
      })
      .addCase(updateOrderAdmin.pending, state => {
        state.order = {
          ...state.order,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(updateOrderAdmin.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.order = {
            ...state.order,
            detail: data,
            isLoading: false,
            isNeedReloadData: true,
          };
        }
      })
      .addCase(updateOrderAdmin.rejected, state => {
        state.order = { ...state.order, isLoading: false };
      })
      .addCase(fetchStatMonthly.pending, state => {
        state.statMonthly = {
          ...state.statMonthly,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchStatMonthly.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.statMonthly = {
            ...state.statMonthly,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchStatMonthly.rejected, state => {
        state.statMonthly = { ...state.statMonthly, isLoading: false };
      })
      .addCase(remindPayment.pending, state => {
        state.reminder = {
          ...state.reminder,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(remindPayment.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.reminder = {
            ...state.reminder,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(remindPayment.rejected, state => {
        state.reminder = { ...state.reminder, isLoading: false };
      })
      .addCase(createRefund.pending, state => {
        state.refund = {
          ...state.refund,
          isLoading: true,
        };
      })
      .addCase(createRefund.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.refund = {
            ...state.refund,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(createRefund.rejected, state => {
        state.refund = { ...state.refund, isLoading: false };
      })
      .addCase(confirmRefund.pending, state => {
        state.refund = {
          ...state.refund,
          isLoading: true,
        };
      })
      .addCase(confirmRefund.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.refund = {
            ...state.refund,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(confirmRefund.rejected, state => {
        state.refund = { ...state.refund, isLoading: false };
      });
  },
});

export const { reloadAdminOrders, resetAdminOrdersData } =
  adminRoomReducer.actions;

export default adminRoomReducer.reducer;
